import { useMemo } from 'react';
import { useStoredEntry } from './useStoredEntry';

export interface ParsedStoredEntry<T> {
  readonly get: () => T | null;
  readonly set: (data: T) => void;
}

export default function useParsedStoredEntry<T>(
  key: string,
): ParsedStoredEntry<T> {
  const storedEntry = useStoredEntry<string>(key);
  return useMemo(
    () => ({
      get: () => {
        const storedValue = storedEntry.get();
        return storedValue != null ? (JSON.parse(storedValue) as T) : null;
      },
      set: (data) => storedEntry.set(JSON.stringify(data)),
    }),
    [storedEntry],
  );
}
